import Component from "./resetPassword";

import {bindActionCreators} from "redux";
import {forgotPassword} from '../../store/actions/session';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const session = state.session;

    return {
        session
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({forgotPassword}, dispatch);
}

export const ResetPassword = connect(mapStateToProps, mapDispatchToProps)(Component);